import { FC, useEffect, MouseEvent } from "react";
import { useMutation } from "react-query";
import {
  dailyRevenueReportExcel,
  dailyRevenueReportPdf,
  dailyRevenueReportSearch,
} from "./services";
import {
  Button,
  CircularProgress,
  Paper,
  TableContainer,
  Typography,
} from "@mui/material";
import { CustomFormField } from "../../utilis/component/CustomFormElement";
import { useForm } from "react-hook-form";
import TableComponent, { TablePropType } from "../component/TableComponent";
import moment from "moment";
import useRepotFile from "../hooks/reportFileHook";
const DailyRevenueReport: FC = () => {
  const { control, reset, getValues } = useForm();
  const {
    mutate: getDailyRevenueReport,
    data: revenueData,
    isLoading: reportLoading,
    reset:dataReset
  } = useMutation(dailyRevenueReportSearch);

  const { mutate: getDailyRevenueReportPdf, isLoading: pdfLoading } =
    useRepotFile({
      apiFunction: dailyRevenueReportPdf,
      responseFileKey: "file",
    });
  const { mutate: getDailyRevenueReportExcel } = useRepotFile({
    apiFunction: dailyRevenueReportExcel,
    fileType: "xlsx",
    // responseFileKey: "file",
  });

  const onChange = () => {
    const data = getValues();
    if (data?.fromDate && data?.toDate) {
      getDailyRevenueReport(data as { fromDate: string; toDate: string });
    }else{
      dataReset()
    }
  };

  const clearForm = () => {
    reset({
      fromDate: "",
      toDate: ""
    });
    dataReset()
  }

  const getFiles = (e: MouseEvent<HTMLButtonElement>) => {
    const fileType = e.currentTarget.dataset.filetype;
    const allData = getValues();
    if (fileType === "pdf") {
      getDailyRevenueReportPdf({
        fromDate: allData.fromDate,
        toDate: allData.toDate,
      });
    } else {
      getDailyRevenueReportExcel({
        fromDate: allData.fromDate,
        toDate: allData.toDate,
      });
    }
  };
  useEffect(() => {
    getDailyRevenueReport({
      fromDate: moment().format("YYYY-MM-DD"),
      toDate: moment().format("YYYY-MM-DD"),
    });
    reset({
      fromDate: moment().format("YYYY-MM-DD"),
      toDate: moment().format("YYYY-MM-DD"),
    });
  }, []);

  return (
    <div className="px-3 py-4 flex flex-col gap-3">
      <Paper>
        <div className="p-4 border-b">
          <Typography color={"primary"} fontWeight={600} fontSize={"1rem"}>
            Daily Revenue Report
          </Typography>
        </div>
        <form
          // onSubmit={handleSubmit(onSubmit)}
          className="grid grid-cols-2 gap-3 p-4"
        >
          <CustomFormField
            control={control}
            element="datepicker"
            name="fromDate"
            fieldProps={{ label: "From Date" }}
            rules={{ required: "From Date is required", onChange }}
          />
          <CustomFormField
            control={control}
            element="datepicker"
            name="toDate"
            fieldProps={{ label: "To Date" }}
            rules={{ required: "TO Date is required", onChange }}
          />
          <div className="col-span-full flex justify-end items-center gap-3">
            {/* <Button
              type="submit"
              disabled={reportLoading}
              endIcon={reportLoading && <CircularProgress size={18} />}
            >
              search
            </Button> */}
            <Button color="error" onClick={clearForm}>
              clear
            </Button>
          </div>
        </form>
      </Paper>

      <TableContainer component={Paper}>
        <div className="flex justify-end gap-3 py-2 px-4 border-b">
          <Button
            disabled={pdfLoading || !Boolean(revenueData?.response?.length)}
            endIcon={pdfLoading && <CircularProgress size={18} />}
            data-filetype="pdf"
            onClick={getFiles}
          >
            pdf
          </Button>
          {/* <Button
            disabled={excelLoading || !Boolean(revenueData?.response?.length)}
            endIcon={excelLoading && <CircularProgress size={18} />}
            data-filetype="excel"
            onClick={getFiles}
          >
            excel
          </Button> */}
        </div>
        <TableComponent
          loading={reportLoading}
          data={revenueData?.response || []}
          tableProps={heading}
        />
      </TableContainer>
    </div>
  );
};

export default DailyRevenueReport;
const heading: TablePropType = [
  { heading: "DATE", key: "createdDate",date:true },
  { heading: "DOCTOR", key: "clinicianName" },
  { heading: "CASH PATIENT", key: "cashpatient" },
  { heading: "INSURANCE PATIENT", key: "inspatient" },
  { heading: "TOTAL AMOUNT", key: "totalAmount",numberType:"round" },
  { heading: "TOTAL DISCOUNT", key: "discount",numberType:"round" },
  { heading: "TOTAL ITEM WISE DISCOUNT", key: "totalDiscountedAmount",numberType:"round" },
  { heading: "TOTAL PATIENT SHARE", key: "patShareTotal",numberType:"round" },
  { heading: "TOTAL INS AMT", key: "insAmount",numberType:"round" },
  { heading: "TOTAL CASH PAYMENT", key: "cashAmount",numberType:"round" },
  { heading: "TOTAL CARD PAYMENT", key: "cardAmount",numberType:"round" },
  { heading: "TOTAL WALLET PAYMENT", key: "walletAmount",numberType:"round" },
];
